<template>

    <!-- Begin TRANSLATE PDF -->
    <v-card class="translate-pdf-container assessment-share-page-btn-action popup-scoring-assessment "
            v-if="isVisible">
        <v-card-title v-if="getPdfTemplateList.length > 0" class="headline">
            <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectTemplate')}}</span>
        </v-card-title>
        <v-card-text v-if="getPdfTemplateList.length > 0">
            <v-flex xs12 sm12 class="no-padding-left">
                <div class="pdf-template-list">

                    <pdf-template-selector-radio-group
                        :selected-template="selectedPdfTemplate"
                        @onChangeSelectedTemplate="selectedPdfTemplate = $event.selectedPdfTemplate"
                    ></pdf-template-selector-radio-group>

                </div>
            </v-flex>
        </v-card-text>
        <v-card-title class="headline">
            <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectLanguage')}}</span>
        </v-card-title>
        <v-card-actions>
            <v-flex xs12 sm12 class="no-padding-left">
                <v-btn v-for="(pdfTranslateLanguage, langIndex) in getPdfTranslateLanguageList"
                       :key="'key-lang-' + langIndex"
                       class="color-on-primary-text"
                       color="primary"
                       @click="downloadTranslatedPdf(selectedPdfTemplate, pdfTranslateLanguage)"
                       :disabled="selectedPdfTemplate === ''"
                       >{{findLanguageNameForDisplay(pdfTranslateLanguage)}}</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
    <!-- End TRANSLATE PDF -->

</template>

<script>

import {mapGetters} from 'vuex';
import PdfTemplateSelectorRadioGroup
    from "../../../../common/components/shared/assessment-share/PdfTemplateSelectorRadioGroup";

export default {
    name: 'TranslatePdfForm',
    components: {
        PdfTemplateSelectorRadioGroup
    },

    props: ['isVisible'],

    data() {
        return {
            selectedPdfTemplate: '',
            // radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
        };
    },

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),

        getPdfTemplateList() {
            return this.getAppPropertyValueArray('PDF_TEMPLATE');
        },
        getPdfTranslateLanguageList() {
            return this.getAppPropertyValueArray('PDF_TRANSLATE_LANGUAGES');
        },
        findTemplateNameForDisplay() {
            return (template) => {
                return (this.text('pdf.template.name.' + template).length > 0)
                    ? this.text('pdf.template.name.' + template)
                    : template;
            };
        },
        findLanguageNameForDisplay() {
            return (langKey) => {
                return (this.text('api.language.name.' + langKey).length > 0)
                    ? this.text('api.language.name.' + langKey.toLowerCase() )
                    : langKey;
            };
        }
    },

    beforeMount() {
        if (this.getPdfTemplateList.length === 1) {
            // If there is only one PDF template, consider it already selected (so it will be automatically selected
            // and no radio buttons for template selection will be displayed).
            this.selectedPdfTemplate = this.getPdfTemplateList[0];
        }
    },

    watch: {
/*        isVisible(isPdfFormVisibleNewValue, isPdfFormVisibleOldValue) {
        // selectedPdfTemplate(newValue, oldValue) {

            // console.log("isVisible. new, old:", isPdfFormVisibleNewValue, isPdfFormVisibleOldValue);
            console.log("isVisible. new, old:", isPdfFormVisibleNewValue, isPdfFormVisibleOldValue);

            if (isPdfFormVisibleNewValue === true) {
                // Create a proper look for checked radio buttons.
                this.$nextTick(() => {
                    let radioElemIcons = document.querySelectorAll('.translate-pdf-container .input-group--selection-controls.radio .input-group__input i.icon.icon--selection-control.icon--radio');
                    // let radios = document.querySelectorAll('.input-group input-group--selection-controls radio primary--text                     > .input-group__input > icon icon--selection-control material-icons');
                    // let radios = document.querySelectorAll('.input-group input-group--selection-controls radio primary--text input-group--active > .input-group__input > icon icon--selection-control material-icons icon--radio');
                    let colorTheme = this.getAppPropertyValue('GUI_THEME_COLOR');
                    console.log("radioElemIcons:", radioElemIcons);

                    radioElemIcons.forEach((radioIcon) => {
                        radioIcon.innerHTML = this.radioButtonPlugin(colorTheme);
                    });
                });
            }
        },*/

/*        selectedPdfTemplate(newValue, oldValue) {

            console.log("selectedPdfTemplate. new, old:", newValue, oldValue);

            // Create a proper look for checked radio buttons.
            this.$nextTick(() => {
                let radioElemIcons = document.querySelectorAll('.translate-pdf-container .input-group--selection-controls.radio .input-group__input i.icon.icon--selection-control.icon--radio');
                let colorTheme = this.getAppPropertyValue('GUI_THEME_COLOR');

                radioElemIcons.forEach((radioIcon) => {
                    radioIcon.innerHTML = this.radioButtonPlugin(colorTheme);
                });
            });
        },*/

    },

    methods: {

        downloadTranslatedPdf(pdfTemplate, languageKey) {
            this.$emit("onDownloadPdf", {
                pdfTemplate,
                languageKey
            })
        }

    }
}

</script>

<style lang="scss" scoped>
    .translate-pdf-container .card__actions .btn {
        margin-bottom: 8px !important;
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-share/forms/TranslatePdfForm.vue